Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default=function(ctx) {
var __t, __p = '';
__p += '<div class="formio-dialog formio-dialog-theme-default formio-modaledit-dialog">\n  <div ref="overlay" class="formio-dialog-overlay"></div>\n  <div ref="content" class="formio-modaledit-content">\n    <button\n      ref="close"\n      type="button"\n      role="button"\n      class="btn btn-primary btn-xs formio-modaledit-close">\n      ' +
((__t = (ctx.t('Close'))) == null ? '' : __t) +
'\n    </button>\n    <div ref="inner" class="reset-margins"></div>\n  </div>\n</div>\n';
return __p
}